angular.module("vgresiduos").controller("ResidueListCtrl", [
	"$stateParams",
	"$rootScope",
	function ($stateParams, $rootScope) {
		"use strict";
		this.$onInit = function () {
			Vgr.util.redirectSingleton($rootScope, "unidade/residuos");
		};
	}
]);
